export const CURSOR_ANCHOR_NAME = 'cursor';
